import React from 'react';
import useStyle from './footerLinks.style';
import { ExternalLink } from 'components/atoms/Links/ExternalLink';
import { useSelector } from 'react-redux';
import { getUserZohoForm } from 'store/selectors/user/user.selectors';
import { generateZohoFormLink } from 'helpers/user/userCreateHelpers';
import usePublicShop from 'hooks/usePublicShop';

export const FooterLinks = () => {
  const classes = useStyle();
  const user = useSelector(getUserZohoForm);
  const { isPublicShop } = usePublicShop();

  return (
    <div className={classes.root}>
      <ExternalLink
        link={
          isPublicShop
            ? 'https://drive.google.com/file/d/1cHrWdNpPHTGmmpdpPjK55p30NqHcIJPj/view'
            : 'https://drive.google.com/file/d/1sPdX2trRQN17zBflN8GtKz-cNo1REqS6/view'
        }
        textInside="Conditions Générales de Vente"
        variant="link"
      />
      <span className={classes.divider}>|</span>
      <ExternalLink
        link="https://linktr.ee/app.fc"
        textInside="Nos réseaux"
        variant="link"
      />
      {!isPublicShop && (
        <>
          <span className={classes.divider}>|</span>
          <ExternalLink
            link={generateZohoFormLink(user)}
            textInside="Contactez-nous"
            variant="link"
          />
        </>
      )}
      <span className={classes.divider}>|</span>
      <ExternalLink
        link="https://france-challenges.com/ressources/politique-protection-donnees/"
        textInside="Protection des données"
        variant="link"
      />
    </div>
  );
};
